import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { ContainerElementExtended } from "../CustomComponents/ContainerElementExtended";
import { LayoutSwitchElement } from "../CustomComponents/LayoutSwitchElement";

@engineComponent(ComponentTypes.DisplayObject)
export class BetElement extends LayoutSwitchElement {
    //******************************************************************************************************************
    //  BET PLACE STATE
    //******************************************************************************************************************

    public static CaseEmpty: string = "EMPTY";
    public static CaseNormal: string = "NORMAL";
    public static CaseWin: string = "WIN";
    public static CaseNoWin: string = "NOWIN";

    //******************************************************************************************************************
    //  FUNCTIONS
    //******************************************************************************************************************

    public setWinPoint(x: number, y: number): void {
        let chips = <ContainerElementExtended>this.getChildElementByName("Chips");

        if (chips != null) {
            chips.setDynamicValues(x, y);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/BetElement.ts
 **/